import React, { useEffect, useState } from "react";
import { getUserProfile } from "../utilities/axios.utilities";
import { url } from "inspector";
import { useNavigate } from "react-router-dom";

interface IProps {
  setIsShowLogout: () => void;
}

const Header: React.FC<IProps> = ({ setIsShowLogout }) => {
  const navigate = useNavigate();

  const [isShowMobile, setShowMobile] = useState(false);

  let userInfoString = localStorage.getItem("user_info");
  const userInfo = userInfoString ? JSON.parse(userInfoString) : null;

  const [userProfile, setUserProfile] = useState<any>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getUserProfile();
        setUserProfile(data);
        localStorage.setItem(
          "user_info",
          JSON.stringify({
            coins: data.coins,
            role: data.role,
            userName: data.username,
          })
        );
      } catch (err) {
        console.error("Error fetching user profile:", err);
      }
    };

    fetchProfile();
  }, []);

  return (
    <header
      style={{
        backgroundImage: "url(/assets/header-bg.png)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
      className="md:px-20 px-1 py-6 md:full w-screen text-important"
    >
      <div className="md:flex hidden justify-between items-center   ">
        {/* pc */}
        <img
          src="/assets/header-logo.png"
          alt="Logo"
          className="cursor-pointer"
          onClick={() => navigate("/")}
        />
        <div className="md:flex hidden gap-1 justify-end">
          <div className="h-[43px] pl-[1px]  flex items-center rounded-3xl bg-white">
            <img src="/assets/coins.png" className="" alt="" />
            <p className="px-2">{userInfo?.coins}</p>
          </div>
          <div className=" h-[43px] pl-[1px]  flex items-center rounded-3xl bg-white">
            <img src="/assets/user-ico.png" alt="" />
            <p className="px-2">{userInfo?.userName}</p>
          </div>
          <button
            className="md:block hidden w-[227px] h-[43px]"
            style={{
              backgroundImage: "url(/assets/btn-logout.png)",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
            onClick={setIsShowLogout}
          />
        </div>
      </div>
      {/* mobile */}
      <div className="md:hidden flex items-center justify-between gap-4">
        <div className="flex gap-2">
          <div className="h-[21px] min-w-[100] pl-[1px] flex items-center rounded-3xl bg-white">
            <img src="/assets/coins.png" className="w-1/4" alt="coin icon" />
            <p className="px-2 text-[12px]">{userInfo?.coins}</p>
          </div>
          <div className=" h-[21px] min-w-[100] pl-[1px] flex items-center rounded-3xl bg-white">
            <img src="/assets/user-ico.png" alt="user icon" className="w-1/4" />
            <p className="px-2 text-[12px]">{userInfo?.userName}</p>
          </div>
        </div>
        <button
          className="w-full flex justify-end"
          // style={{
          //   backgroundImage: "url(/assets/btn-logout.png)",
          //   backgroundRepeat: "no-repeat",
          //   backgroundPosition: "center",
          //   backgroundSize: "cover",
          // }}
          onClick={setIsShowLogout}
        >
          <img
            className="w-[100px] h-[30px]"
            src="/assets/btn-logout.png"
            alt="Đăng Xuất"
          />
        </button>
      </div>
    </header>
  );
};

export default Header;
